import { createSelector } from 'reselect'

import CONFIG from 'config'

const getBanksState = state => state.banks

export const getBanks = createSelector([getBanksState], banks => {
  if (banks && banks.data) {
    return {
      highlighted: banks.data.find(item => item.bankfOutstanding),
      cards: banks.data.map(data => ({
        card: data.bankfBankidCardid,
        bestInstallments: data.bankfBinstallments,
        cft: data.bankfCft,
        description: data.bankfDescription,
        installments: data.bankfInstallments,
        logo: CONFIG.CONTENT_CDN_BASE_URL + data.bankfLogo,
        milesArplus: data.bankfMilesArplus,
        tea: data.bankfTea,
        terms: data.bankfTerms,
        url: data.bankfUrl && data.bankfUrl.replace(/&amp;/g, `&`),
        id: data.nid,
        title: data.title,
        alt: data.bankfAltText
      }))
    }
  }

  return []
})

export const getBanksData = createSelector([getBanksState], state => (state ? state.data : null))

export const isFetchingBanks = createSelector([getBanksState], getBanksData =>
  getBanksData ? getBanksData.isFetching : null
)
